// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"263":"75c09f53","531":"88c00669"}[chunkId] + ".chunk.js";
};